import { RpiTable } from "../../rpi-core/table/RpiTable";
import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useNavigateRoute } from "../../hooks/useNavigateRoute";
import { Menu } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import {
  customerProductColumnsSuperAdmin,
  customerProductColumns,
} from "../../configuration/columns/customerProduct.column";
import { createRpaTableMenuColumn, RpaTableMenu } from "../../components/RpaTableMenu";
import { RpiTableContainer } from "../../components/RpiTableContainer";
import React from "react";

type CustomerProductsType = GraphQLPagedQueryData<GraphQL.CustomerProductsQuery>;
type CustomerProductsSuperAdminType = GraphQLPagedQueryData<GraphQL.CustomerProductsSuperAdminQuery>;

export interface CustomerProductsTableProps {
  customerProducts?: (CustomerProductsType | CustomerProductsSuperAdminType)[];
  isLoading: boolean;
  error?: unknown;
  setIsPriceCalculatorOpen: (open: boolean) => void;
  setProductId: (id: number | undefined) => void;
  footer?: React.ReactNode;
}

export function CustomerProductsTable({
  customerProducts,
  isLoading,
  error,
  setIsPriceCalculatorOpen,
  setProductId,
  footer,
}: CustomerProductsTableProps) {
  const user = useAuthUser();
  const columnDefs = user.is.SUPER_ADMIN ? customerProductColumnsSuperAdmin : customerProductColumns;

  return (
    <RpiTableContainer data-testid="customer-products-table" footer={footer}>
      <RpiTable
        isLoading={isLoading}
        error={error}
        emptyMessage={"No products found."}
        perPage={customerProducts?.length}
        data={customerProducts}
        columns={columnDefs}
        additionalColumns={[
          createRpaTableMenuColumn<CustomerProductsType | CustomerProductsSuperAdminType>((row) => (
            <ProductsActionMenu
              customerProductId={row.id}
              onOpenPriceCalculator={() => {
                setProductId(row.id);
                setIsPriceCalculatorOpen(true);
              }}
            />
          )),
        ]}
      />
    </RpiTableContainer>
  );
}

type ProductsActionMenuProps = {
  customerProductId: number;
  onOpenPriceCalculator: () => void;
};
function ProductsActionMenu({ customerProductId, onOpenPriceCalculator }: ProductsActionMenuProps) {
  const user = useAuthUser();
  const navigateRoute = useNavigateRoute();
  return (
    <RpaTableMenu>
      {!user.is.SUPER_ADMIN && (
        <Menu.Item
          icon={<IconV3 icon="edit" size={20} />}
          onClick={() => navigateRoute(["customer-product:edit", { id: customerProductId }])}
        >
          Edit
        </Menu.Item>
      )}
      <Menu.Item icon={<IconV3 icon="attach_money" size={20} />} onClick={onOpenPriceCalculator}>
        Price Calculator
      </Menu.Item>
    </RpaTableMenu>
  );
}
